module.exports = __webpack_public_path__ + "img/square_header_acmed.7ec99ea6.png";